<template>

    <svg :id="id" ref='drawAreaRef' style='height:100%;  width:100%'></svg>

</template>

<script>

import * as d3 from 'd3'
import * as d3Scale from 'd3-scale'
import * as d3Shape from 'd3-shape'
// import * as saveSvgAsPng from 'save-svg-as-png'
// import 'd3-svg-to-png'

export default {
  name: 'MiniMetro',
  props: {
    lines: Array,
    id: String,
    options: Object
  },
  data () {
    return {
      liness: null,
      lineStroke: 10
    }
  },

  mounted () {
    this.renderMap(this.lines)
  },

  methods: {
    renderMap (lines) {
      // Create the color scale
      /* var colorScale = d3Scale.scaleOrdinal(['#4E79A7', '#F28E2B',
        '#59A14F', '#B6992D', '#499894', '#E15759',
        '#79706E', '#D37295', '#B07AA1',
        '#9D7660', '#A0CBE8', '#FFBE7D',
        '#8CD17D', '#F1CE63',
        '#86BCB6', '#FF9D9A', '#BAB0AC',
        '#FABFD2', '#D4A6C8', '#D7B5A6']) */

      /* colorScale = d3Scale.scaleOrdinal(['#8dd3c7', '#fb8072',
        '#80b1d3', '#b3de69', '#bebada', '#ffed6f',
        '#9467BD', '#d9d9d9', '#bc80bd',
        '#ffffb3', '#ccebc5', '#fccde5'])

      var colorScale = d3Scale.scaleOrdinal(['#1F77B4', '#FF7F0E',
        '#2CA02C', '#D62728', '#17BECF', '#FF9896',
        '#9467BD', '#8C564B', '#E377C2',
        '#F700C2', '#7F7F7F', '#BCBD22',
        '#9EDAE5', '#AEC7E8',
        '#FFBB78', '#98DF8A', '#C5B0D5',
        '#C49C94', '#C7C7C7', '#DBDB8D'])
      */

      if (this.options['width'] === undefined || this.options['height'] === undefined) {
        this.options['width'] = this.options.drawArea
        this.options['height'] = this.options.drawArea
      }

      var margin = { top: 10, left: 10, right: 10, bottom: 10 }
      var dW = (this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) / (this.options.width)
      var dH = (this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) / (this.options.height)
      var scale = 1
      var translateX = 0
      var translateY = 0

      if (dW > dH) {
        scale = dH
        translateX = ((this.$refs.drawAreaRef.clientWidth - margin.left - margin.right) - this.options.width * scale) / 2
        translateY = margin.top
      } else {
        scale = dW
        translateY = ((this.$refs.drawAreaRef.clientHeight - margin.top - margin.bottom) - this.options.height * scale) / 2
        translateX = margin.left
      }

      var xScale = d3Scale.scaleLinear().domain([0, this.options.width]).range([0, this.options.width])
      var yScale = d3Scale.scaleLinear().domain([0, this.options.height]).range([0, this.options.height])

      var svg = d3.select('#' + this.id)
        .append('g')
        .attr('transform', 'translate(' + translateX + ',' + translateY + ') scale(' + scale + ',' + scale + ')')

      var lineGroup = svg
        .selectAll('.line')
        .data(lines)
        .enter()

      var line = d3Shape.line().curve(d3.curveCardinal.tension(0.90)).x(d => {
        return xScale(d['X'] + this.lineStroke * d['VX'])
      }).y(d => yScale(d['Y'] + this.lineStroke * d['VY']))

      lineGroup
        .append('path')
        .attr('id', d => d['Label'])
        .attr('class', 'line')
        .attr('d', d => line(d['Points']))
        .style('z-index', -3)
        .style('fill', 'none')
        .style('stroke', d => d['Color'])
        // .style('stroke', d => colorScale(d['Label']))
        .style('stroke-width', this.lineStroke)
    }
  }
}
</script>

<style scoped>

</style>
